import { render } from "./WarehouseSettingsHub.vue?vue&type=template&id=56b4731b&scoped=true"
import script from "./WarehouseSettingsHub.vue?vue&type=script&lang=js"
export * from "./WarehouseSettingsHub.vue?vue&type=script&lang=js"

import "./WarehouseSettingsHub.vue?vue&type=style&index=0&id=56b4731b&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b4731b"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon,QItemLabel});
